/** Rotas públicas que não devem bloquear no bootstrap de sessão (LCP / Lighthouse). */
const PUBLIC_BOOTSTRAP_BYPASS_PATHS = [
  '/',
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/ativar-conta',
  '/verificar-email',
  '/assinar',
  '/escolher-plano',
  '/planos',
] as const;

export const isPublicBootstrapBypassPath = (pathname: string): boolean => {
  return PUBLIC_BOOTSTRAP_BYPASS_PATHS.some(
    (publicPath) => pathname === publicPath || pathname.startsWith(`${publicPath}/`)
  );
};
